import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const licenseGet = createAsyncThunk('license/get', async () => {
  return await apiInstance.get('/license/get');
});

export const licenseDecode = createAsyncThunk('license/decode', async () => {
  return await apiInstance.get('/license/decode');
});

export const licenseAdd = createAsyncThunk('license/add', async (payload) => {
  return await apiInstance.post('/license/add', payload);
});

export const licenseUpdate = createAsyncThunk('license/update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/license/update/${id}`, rest);
});

const initialState = {};

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState,
  reducers: {
    clearAdminDashboardSlice: () => initialState
  },
  extraReducers: (builder) => {}
});

export default adminDashboardSlice.reducer;
export const { clearAdminDashboardSlice } = adminDashboardSlice.actions;
